<div class="container">
  <h1 class="text-orange text-2xl">Impressum</h1>
  <address class="mt-4 text-gray text-normal not-italic">
    GLANZ UND GLORIA<br />
    Agentur für Kommunikation UG (hb)<br />
    Herlingsburg 6-10<br />
    22529 Hamburg
  </address>

  <p class="text-gray mt-4">
    <a href="tel:+494033425133">T +49 40 334 251 33</a><br />
    F +49 40 334 251 35
  </p>

  <p class="text-gray mt-4">
    Sitz der Gesellschaft: Hamburg, Amtsgericht Hamburg, HRB116208, USt-IdNr: DE275581278<br />
    Geschäftsführende Gesellschafterin: Viola Frank
  </p>

  <h3 class="text-orange mt-4">Haftung für Inhalte</h3>
  <p class="text-gray mt-1">
    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität
    der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
    Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
    Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder
    nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder
    Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
    Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei bekannt werden
    von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
  </p>

  <h3 class="text-orange mt-4">Urheberrecht</h3>
  <p class="text-gray mt-1">
    Die auf dieser Website veröffentlichten Inhalte und Werke sind urheberrechtlich geschützt. Jede vom deutschen
    Urheberrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Autors oder
    Urhebers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw.
    Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Beiträge Dritter
    sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder
    kompletter Seiten ist nicht gestattet. Einige Projekte sind im Zuge vorheriger Anstellungen bei anderen Agenturen
    entstanden. Alle anderen Projekte sind Ergebnisse der Arbeit als Freelancer und der GLANZ UND GLORIA UG.
  </p>

  <h3 class="text-orange mt-4">Datenschutz</h3>
  <p class="text-gray mt-1">
    Informationen zum Datenschutz finden Sie in auf unserer
    <a href="/datenschutz" class="text-orange">Datenschutz-Seite</a>.
  </p>

  <h3 class="text-orange mt-4">Copyright</h3>
  <p class="text-gray mt-1 mb-8">
    © 2015 GLANZ UND GLORIA UG<br />
    Alle Elemente dieser Webseite (Text, Grafiken, Logos, Designs, Layouts und Fotografien) sind geschützt durch das deutsche
    Copyright Gesetz. Diese dürfen nicht ohne Erlaubnis benutzt und reproduziert werden. Alle Rechte vorbehalten. Das Copyright
    der gezeigten Arbeiten liegt je nach Beauftragung bei der GLANZ UND GLORIA UG oder ihren Kunden.
  </p>
</div>
